export const SCRATCH = 'SCRATCH';
export const WOOF = 'WOOF';
export const WEB = 'WEB';
export const ACCOUNT = 'ACCOUNT';
export const ANSWERED = 'ANSWERED';